var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form-item',{attrs:{"label":_vm.currentField.label,"required":this.currentField.isRequired}}),_c('div',{attrs:{"span":_vm.currentField.span}},[_c('bar-chart',{attrs:{"chart-data":_vm.datacollection}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }